import React from 'react';
import PropTypes from 'prop-types';

export default function CostRubric({ fateCost, isFree }) {
  if (isFree) {
    return <p className="descriptive">Changing your face is free, just this once.</p>;
  }
  return (
    <p className="descriptive">
      {`This will immediately deduct ${fateCost} Fate.`}
    </p>
  );
}

CostRubric.propTypes = {
  isFree: PropTypes.bool.isRequired,
  fateCost: PropTypes.number.isRequired,
};